import { render } from "./VillageNpc2.vue?vue&type=template&id=776b4e70&scoped=true"
import script from "./VillageNpc2.vue?vue&type=script&lang=js"
export * from "./VillageNpc2.vue?vue&type=script&lang=js"

import "./VillageNpc2.vue?vue&type=style&index=0&id=776b4e70&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776b4e70"]])

export default __exports__